module.exports = __webpack_public_path__ + "img/pin2.b23d8eec.svg";